import { Form, Input, message } from "antd";
import * as COMMONS from "common/common";
import { motion } from "framer-motion";
import { useCopyToClipboard } from "react-use";

const { TextArea } = Input;

/**
 * @typedef {Object} Props
 *
 * @typedef {Object} MessageAttribute
 * @property {string} value
 * @property {string} label
 *
 * @callback HandlerCopyToClipboard
 * @param {string} attribute
 * @returns {void}
 */

/** @type {MessageAttribute[]} */
const MESSAGE_ATTRIBUTES = [
	{
		value: "PRESENT",
		label: "を入力すると、配信の時にイベント名に変換されます。",
	},
	{
		value: "CAMPAIGN",
		label: "を入力すると、配信の時にお客様の名前に変換されます。",
	},
	{
		value: "NAME",
		label: "を入力すると、配信の時にお客様の名前に変換されます。",
	},
	{
		value: "DATE",
		label: "を入力すると、配信の時に予約の日付に変換されます。",
	},
	{
		value: "COMPANY-TEL",
		label: "を入力すると、配信の時に問い合わせ電話番号に変換されます。",
	},
];

/**
 * @param {Props} props
 * @returns {JSX.Element}
 * */
const WinningMessage = (props) => {
	const [, copyToClipboard] = useCopyToClipboard();

	/** @type {HandlerCopyToClipboard} */
	const handleCopyToClipboard = (attribute) => {
		copyToClipboard(`[${attribute}]`);
		message.success(`[${attribute}]をコピーしました`);
	};

	return (
		<motion.div variants={COMMONS.ANIMATION_VARIANT_STAGGER_ITEM}>
			<Form.Item
				name="winningMessage"
				label="当選に配信されるメッセージ"
				extra={
					<div className="flex flex-col">
						{MESSAGE_ATTRIBUTES.map((attribute, key) => (
							<p
								key={key}
								onClick={() => handleCopyToClipboard(attribute.value)}
							>
								※メッセージに
								<span className="cursor-pointer">[{attribute.value}]</span>
								{attribute.label}
							</p>
						))}
					</div>
				}
			>
				<TextArea placeholder="メッセージを入力してください" autoSize />
			</Form.Item>
		</motion.div>
	);
};

export default WinningMessage;
